<template>
  <div class="toggle" :class="{ 'sm': size === 'sm', 'active': value }" @keydown.space.prevent="toggle" @click="toggle">
    <input type="checkbox" :id="id" :name="name" :disabled="disabled" :checked="value" />
    <span class="track"></span>
    <span class="indicator">
      <div class="thumb"></div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Toggle',

  props: {
    value: {
      type: Boolean,
      required: true
    },

    id: {
      type: String
    },

    name: {
      type: String
    },

    disabled: {
      type: Boolean
    },

    size: {
      type: String
    }
  },

  methods: {
    toggle () {
      if (!this.disabled) {
        this.$emit('update:value', !this.value)
        this.$emit('change')
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
  .toggle {
    @apply inline-block relative cursor-pointer h-6 w-10 rounded-full flex-none;

    &.sm {
      @apply h-5 w-8;
    }

    input {
      @apply sr-only;
    }
  }

  .toggle:focus {
    @apply outline-none ring;
  }

  .track {
    @apply bg-gray-300 inline-block rounded-full h-full w-full transition duration-200 ease-linear;
  }

  .indicator {
    @apply absolute p-1 left-0 top-0 rounded-full transition duration-200 ease-linear;
  }

  .thumb {
    @apply h-4 w-4 bg-white rounded-full shadow-sm;

    .sm & {
      @apply h-3 w-3;
    }
  }

  input {
    &:checked ~ .indicator {
      @apply transform translate-x-4;

      .sm & {
        @apply translate-x-3
      }
    }

    &:checked ~ .track {
      @apply transform transition-colors bg-emerald-400;
    }

    &:disabled ~ .track {
      @apply bg-gray-200;
    }

    &:disabled ~ .thumb {
      @apply bg-gray-50 border-gray-200;
    }

    &:focus + .track,
    &:active + .track {
      @apply ring;
    }
  }
</style>
